import List, { HeadCell } from 'components/list/list';
import ListCell from 'components/list/list-cell';
import NewListRow from 'components/new-list-row';
import React from 'react';
import { FormattedNumber, useIntl } from 'react-intl';
import { OrderLine } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders.list';

type Props = {
  orderLines: OrderLine[];
};

const OrderProductsList: React.FC<Props> = ({ orderLines }) => {
  const intl = useIntl();
  const bodyColumns: HeadCell[] = [
    {
      id: 'product',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.body.product` }),
    },
    {
      id: 'quantity',
      align: 'right',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.quantity` }),
    },
  ];

  return (
    <List dark options={bodyColumns}>
      {orderLines.map((line, idx) => (
        <NewListRow key={idx}>
          <ListCell>{line.itemName}</ListCell>
          <ListCell align="right">
            <FormattedNumber
              value={line.orderQuantity}
              style={`unit`}
              unit={'kilogram'}
              minimumFractionDigits={0}
              maximumFractionDigits={0}
            />
          </ListCell>
        </NewListRow>
      ))}
    </List>
  );
};

export default React.memo(OrderProductsList);
